/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
const { cloneDeep } = require('lodash');

function removePropertiesForItProduct(
  payload,
  queryName,
  currentProduct = 'MSP'
) {
  /** Add the query name and the corresponding payload to be removed */
  function propertiesToRemoved(apiName) {
    switch (apiName) {
      case 'createMailbox':
      case 'updateMailbox':
        return {
          keysToBeRemoved: ['client', 'site']
        };
      case 'saveTicket':
      case 'saveTicketSchedule':
      case 'updateTicketSchedule':
      case 'createAsset':
      case 'shareReport':
        return {
          keysToBeRemoved: ['client']
        };
      case 'updateNetworkCredential':
      case 'createNetworkCredential':
      case 'updateEndpointCredential':
      case 'createEndpointCredential':
        return {
          keysToBeRemoved: ['clientId']
        };
      case 'createServiceItem':
      case 'updateServiceItem':
        return {
          keysToBeRemoved: [],
          keysToBeAdded: [
            'name',
            'invoiceDescription',
            'category',
            'itemId',
            'quantityType'
          ]
        };
      case 'updateTechGroup':
        return {
          keysToBeRemoved: [
            'clientList',
            'associateClients',
            'disassociateClients'
          ]
        };
      case 'createProject':
        return {
          keysToBeRemoved: ['client']
        };
      case 'updateWorklogTimerEntry':
      case 'editWorklogEntry':
      case 'createWorklogTimerEntry':
        return {
          keysToBeRemoved: ['serviceItem', 'serviceCatalogItem']
        };
      case 'updateTicketForm':
      case 'createTicketForm':
        return {
          keysToBeRemoved: [
            'clientVisibility',
            'addClients',
            'deleteClients',
            'clients'
          ]
        };
      default:
        return [];
    }
  }
  // if it is MSP product return the payload, also setting the default to MSP to avoid any uninitional errors
  if (currentProduct === 'MSP') {
    return payload;
  }
  function removeProperties(obj, propsToRemove) {
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        removeProperties(obj[key], propsToRemove);
      }

      if (propsToRemove.includes(key)) {
        delete obj[key];
      }
    }
    return obj;
  }
  function addProperties(payloads, propsToAdd) {
    const newPayload = {};
    propsToAdd.forEach((value) => {
      newPayload[value] = payloads[value];
    });
    return newPayload;
  }
  // keys to be removed
  const listOfPropToRemove =
    propertiesToRemoved(queryName)?.keysToBeRemoved || [];
  const listOfPropToAdd = propertiesToRemoved(queryName)?.keysToBeAdded || [];

  if (listOfPropToRemove.length) {
    const clonedObj = cloneDeep(payload);
    const updatedPayload = removeProperties(clonedObj, listOfPropToRemove);
    // /* setting it true for all the APis that is coming through this method,
    //   on the querying side, please put @include(if : $isMSPProduct) for properties not related to IT
    // */
    // updatedPayload.isMSPProduct = true;
    return updatedPayload;
  }
  if (listOfPropToAdd.length) {
    return addProperties(payload, listOfPropToAdd);
  }
  return payload;
}
export { removePropertiesForItProduct };
